// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"645": "GuestLazyComponent","787": "BadgeTooltipV1",}[chunkId] + "." + {"645": "35a473229f6b9218","787": "4879d016ff4b2736",}[chunkId] + ".js"
}